const ICONS_BASE_PATH: string = 'public/icons/';

// Map of all icons and their relative paths
const ICONS = {
    add: 'add.svg#root',
    'add-circle': 'add-circle.svg#root',
    'add-note': 'add-note.svg#root',
    'arrow-left': 'arrow-left.svg#root',
    'arrow-right': 'arrow-right.svg#root',
    cancel: 'cancel.svg#root',
    'cancel-circle': 'cancel-circle.svg#root',
    check: 'check.svg#root',
    'check-circle': 'check-circle.svg#root',
    'check-circle-outlined': 'check-circle-outlined.svg#root',
    'chevron-down': 'chevron-down.svg#root',
    'chevron-left': 'chevron-left.svg#root',
    'chevron-right': 'chevron-right.svg#root',
    comment: 'comment.svg#root',
    copy: 'copy.svg#root',
    delete: 'delete.svg#root',
    dilitrust: 'dilitrust.svg#root',
    download: 'download.svg#root',
    'drag-handle': 'drag-handle.svg#root',
    edit: 'edit.svg#root',
    email: 'email.svg#root',
    fingerprint: 'fingerprint.svg#root',
    'germany-flag': 'germany.svg#root',
    help: 'help.svg#root',
    info: 'info.svg#root',
    'info-circle': 'info-circle.svg#root',
    key: 'key.svg#root',
    lock: 'lock.svg#root',
    menu: 'menu.svg#root',
    'more-horizontal': 'more-horizontal.svg#root',
    'more-vertical': 'more-vertical.svg#root',
    notifications: 'notifications.svg#root',
    open: 'open.svg#root',
    pdf: 'pdf.svg#root',
    'rounded-arrow-down': 'rounded-arrow-down.svg#root',
    sign: 'sign.svg#root',
    signature: 'signature.svg#root',
    support: 'support.svg#root',
    'united-kingdom-flag': 'united-kingdom.svg#root',
    upload: 'upload.svg#root',
    user: 'user.svg#root',
    'user-add': 'user-add.svg#root',
    'user-check': 'user-check.svg#root',
    'user-edit': 'user-edit.svg#root',
    verified: 'verified.svg#root',
    warning: 'warning.svg#root',
} as const;

export type IconType = keyof typeof ICONS;

/**
 * Generates the path of an icon.
 * @param type The target icon.
 */
export function getIconPath(type: IconType): string {
    return `${ ICONS_BASE_PATH }${ ICONS[type] }`;
}